import React from 'react';
import { XIcon, MinusIcon, PlusIcon, TrashIcon, ShoppingBagIcon } from 'lucide-react';
import { useCart } from '../contexts/CartContext';
interface CartModalProps {
  isOpen: boolean;
  onClose: () => void;
}
export function CartModal({
  isOpen,
  onClose
}: CartModalProps) {
  const {
    cartItems,
    removeFromCart,
    updateQuantity,
    cartTotal,
    clearCart
  } = useCart();
  if (!isOpen) return null;
  return <>
      {/* Backdrop */}
      <div className="fixed inset-0 bg-black bg-opacity-50 z-50 transition-opacity" onClick={onClose} data-id="element-10" />
      {/* Modal */}
      <div className="fixed right-0 top-0 h-full w-full sm:w-96 bg-white z-50 shadow-2xl transform transition-transform" data-id="element-11">
        <div className="flex flex-col h-full" data-id="element-12">
          {/* Header */}
          <div className="flex items-center justify-between p-4 border-b border-gray-200" data-id="element-13">
            <div className="flex items-center gap-2" data-id="element-14">
              <ShoppingBagIcon className="w-6 h-6 text-red-600" data-id="element-15" />
              <h2 className="text-xl font-bold text-gray-900" data-id="element-16">Shopping Cart</h2>
            </div>
            <button onClick={onClose} className="p-2 hover:bg-gray-100 rounded-md transition" data-id="element-17">
              <XIcon className="w-5 h-5" data-id="element-18" />
            </button>
          </div>
          {/* Cart Items */}
          <div className="flex-1 overflow-y-auto p-4" data-id="element-19">
            {cartItems.length === 0 ? <div className="flex flex-col items-center justify-center h-full text-gray-500" data-id="element-20">
                <ShoppingBagIcon className="w-16 h-16 mb-4 text-gray-300" data-id="element-21" />
                <p className="text-lg font-medium" data-id="element-22">Your cart is empty</p>
                <p className="text-sm mt-2" data-id="element-23">Add some items to get started!</p>
              </div> : <div className="space-y-4" data-id="element-24">
                {cartItems.map(item => <div key={item.id} className="flex gap-4 p-3 bg-gray-50 rounded-lg hover:bg-gray-100 transition" data-id="element-25">
                    <img src={item.image} alt={item.name} className="w-20 h-20 object-cover rounded-md" data-id="element-26" />
                    <div className="flex-1" data-id="element-27">
                      <h3 className="font-medium text-gray-900 text-sm line-clamp-2" data-id="element-28">
                        {item.name}
                      </h3>
                      <p className="text-red-600 font-bold mt-1" data-id="element-29">
                        ${item.price.toFixed(2)}
                      </p>
                      <div className="flex items-center gap-2 mt-2" data-id="element-30">
                        <button onClick={() => updateQuantity(item.id, item.quantity - 1)} className="p-1 bg-white border border-gray-300 rounded hover:bg-gray-50 transition" data-id="element-31">
                          <MinusIcon className="w-3 h-3" data-id="element-32" />
                        </button>
                        <span className="text-sm font-medium w-8 text-center" data-id="element-33">
                          {item.quantity}
                        </span>
                        <button onClick={() => updateQuantity(item.id, item.quantity + 1)} className="p-1 bg-white border border-gray-300 rounded hover:bg-gray-50 transition" data-id="element-34">
                          <PlusIcon className="w-3 h-3" data-id="element-35" />
                        </button>
                        <button onClick={() => removeFromCart(item.id)} className="ml-auto p-1 text-red-600 hover:bg-red-50 rounded transition" data-id="element-36">
                          <TrashIcon className="w-4 h-4" data-id="element-37" />
                        </button>
                      </div>
                    </div>
                  </div>)}
              </div>}
          </div>
          {/* Footer */}
          {cartItems.length > 0 && <div className="border-t border-gray-200 p-4 space-y-4" data-id="element-38">
              <div className="flex items-center justify-between text-lg font-bold" data-id="element-39">
                <span data-id="element-40">Total:</span>
                <span className="text-red-600" data-id="element-41">${cartTotal.toFixed(2)}</span>
              </div>
              <button className="w-full bg-red-600 text-white py-3 rounded-md hover:bg-red-700 transition font-medium" data-id="element-42">
                Checkout
              </button>
              <button onClick={clearCart} className="w-full bg-gray-100 text-gray-700 py-2 rounded-md hover:bg-gray-200 transition text-sm" data-id="element-43">
                Clear Cart
              </button>
            </div>}
        </div>
      </div>
    </>;
}